var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.tab.claim_settlement")) + " "), _c('v-spacer'), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "elevation": "0"
    },
    on: {
      "click": _vm.send
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v(" mdi-send-variant-outline ")]), _vm._v(" " + _vm._s(_vm.$t("submit")) + " ")], 1), _c('m-icon-button', {
    on: {
      "click": _vm.edit
    }
  })], 1), _c('v-card-text', [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.report.liabilitySharePercent'),
      "readonly": "",
      "value": typeof _vm.value.liabilitySharePercent === 'number' ? (_vm.value.liabilitySharePercent / 100).toLocaleString('de-DE', {
        style: 'percent'
      }) : '',
      "hide-details": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('m-select', {
    attrs: {
      "label": _vm.$t('objects.report.isDeductions'),
      "readonly": "",
      "items": [true, false],
      "append-icon": _vm.readonly ? '' : undefined,
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-chip', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("".concat(item ? "yes" : "no"))) + " ")])];
      }
    }, {
      key: "item",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.$t("".concat(item ? "yes" : "no"))) + " ")];
      }
    }]),
    model: {
      value: _vm.value.isDeductions,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "isDeductions", $$v);
      },
      expression: "value.isDeductions"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('m-select', {
    attrs: {
      "label": _vm.$t('objects.report.isDepreciationCredit'),
      "readonly": "",
      "items": [true, false],
      "append-icon": _vm.readonly ? '' : undefined,
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-chip', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("".concat(item ? "yes" : "no"))) + " ")])];
      }
    }, {
      key: "item",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(_vm.$t("".concat(item ? "yes" : "no"))) + " ")];
      }
    }]),
    model: {
      value: _vm.value.isDepreciationCredit,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "isDepreciationCredit", $$v);
      },
      expression: "value.isDepreciationCredit"
    }
  })], 1)], 1)], 1), _c('claim-settlement-update-dialog', {
    attrs: {
      "isOpen": _vm.isDialogOpen
    },
    on: {
      "update:isOpen": function updateIsOpen($event) {
        _vm.isDialogOpen = $event;
      },
      "update:is-open": function updateIsOpen($event) {
        _vm.isDialogOpen = $event;
      }
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }), _c('claim-settlement-send-dialog', {
    attrs: {
      "report": _vm.value
    },
    model: {
      value: _vm.isSendDialogOpen,
      callback: function callback($$v) {
        _vm.isSendDialogOpen = $$v;
      },
      expression: "isSendDialogOpen"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }